const globals = window || this || {};

export default globals;
